/**
 * Общие переменные, используемые в теме
 */

export const defaultRadius = 3;

export const sharedVariables = {
  borderRadius: defaultRadius,
  spacingUnit: 8,
};
